/**
 * De `imagen_url` a un `src` que el navegador pueda pedir.
 *
 * POR QUE NO ALCANZA CON PONER LA COLUMNA EN EL `src`
 * --------------------------------------------------
 * `imagen_url` guarda dos cosas distintas:
 *
 *   · Una foto subida al sistema: `/publico/imagenes/producto/808?v=3`. Es una
 *     ruta de la API, y la base de la API no siempre es el mismo origen — con
 *     `VITE_API_URL` apuntando a un backend remoto, `/publico/...` cae en el
 *     servidor del front y da 404.
 *   · Una URL pegada a mano desde la ficha: `https://...`. Esa va tal cual.
 *
 * La regla es una sola: si empieza con barra, es nuestra y le va la base.
 */
import { URL_API } from "@/lib/api";

export function srcImagen(imagenUrl: string | null | undefined): string | null {
  if (!imagenUrl) return null;
  return imagenUrl.startsWith("/") ? `${URL_API}${imagenUrl}` : imagenUrl;
}

/**
 * La misma foto, pero para la pantalla de configuracion.
 *
 * Ahi hay que VER la foto de algo que todavia no se publico —cargarla antes de
 * publicar es el orden natural del trabajo— y la ruta publica esconde
 * justamente eso. Por eso las fotos del sistema se piden por la ruta con
 * sesion; una URL pegada a mano desde la ficha sigue yendo tal cual.
 *
 * La version viaja igual: sin ella, reemplazar una foto dejaria la anterior en
 * pantalla hasta recargar.
 */
/**
 * La foto propia de una oferta, para Tienda online: por la ruta con sesion,
 * porque la publica solo sirve la de una oferta activa y aca se le carga la
 * foto a una que todavia no se ve (0110).
 */
export function srcImagenOfertaAdmin(
  imagenUrl: string | null | undefined,
  ofertaId: number,
): string | null {
  if (!imagenUrl) return null;
  const version = new URLSearchParams(imagenUrl.split("?")[1] ?? "").get("v") ?? "1";
  return `${URL_API}/ofertas/${ofertaId}/imagen?v=${version}`;
}

export function srcImagenAdmin(
  imagenUrl: string | null | undefined,
  productoId: number,
): string | null {
  if (!imagenUrl) return null;
  if (!imagenUrl.startsWith("/publico/imagenes/producto/")) return srcImagen(imagenUrl);

  const version = new URLSearchParams(imagenUrl.split("?")[1] ?? "").get("v") ?? "1";
  return `${URL_API}/productos/${productoId}/imagen?v=${version}`;
}
